function isEmpty(...items) {
  return !items.some((item) => {
    if (typeof item === "number") {
      return true;
    }
    if (typeof item === "string") {
      if (item.trim().length > 0) {
        return true;
      }
    }
    if (Array.isArray(item)) {
      if (item.length > 0) {
        return true;
      }
    }

    return false;
  });
}

export default isEmpty;
